import * as componentConstants from '../constants/componentConstants';
import * as objectConstants from '../constants/objectConstants';

//MENUS


export const MENU_TYPE_LINEAR_LEARNING_PLAN = {
    constant: componentConstants.MENU_TYPE_LINEAR_LEARNING_PLAN,
    component: componentConstants.COMPONENT_LEARNING_PLAN
};


export const MENU_TYPE_OPEN_LEARNING_PLAN = {
    constant: componentConstants.MENU_TYPE_OPEN_LEARNING_PLAN,
    component: componentConstants.COMPONENT_LEARNING_PLAN
};


export const MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN = {
    constant: componentConstants.MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN,
    component: componentConstants.COMPONENT_LEARNING_PLAN
};

export const MENU_TYPE_PERSONAL_LEARNING_PLAN = {
    constant: componentConstants.MENU_TYPE_PERSONAL_LEARNING_PLAN,
    component: componentConstants.COMPONENT_LEARNING_PLAN
};

// EXPORT ARRAY OF ALL BITES
export const MENU_TYPES = [
    MENU_TYPE_LINEAR_LEARNING_PLAN,
    MENU_TYPE_OPEN_LEARNING_PLAN,
    MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN,
    MENU_TYPE_PERSONAL_LEARNING_PLAN
];

//BITES

const SCENARIO_BITE = {
    constant: componentConstants.BITE_TYPE_SCENARIO,
    component: componentConstants.COMPONENT_SCENARIO_BITE
};

// EXPORT ARRAY OF ALL BITES
export const BITE_TYPES = [
    SCENARIO_BITE
];


const SCENARIO_SCREEN = {
    constant: componentConstants.SCREEN_TYPE_SCENARIO,
    component: componentConstants.COMPONENT_SCENARIO_SCREEN,
    isAdaptive: false,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {},
        xs: {}
    }
};

const SCROLL_SCREEN = {
    constant: componentConstants.SCREEN_TYPE_SCROLL,
    component: componentConstants.COMPONENT_SCROLL_SCREEN,
    resourcesComponent: componentConstants.COMPONENT_RESOUCES_SCROLL_SCREEN,
    isAdaptive: false,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {},
        xs: {}
    }
};

const TABBED_SCREEN = {
    constant: componentConstants.SCREEN_TYPE_TABBED,
    component: componentConstants.COMPONENT_TABBED_SCREEN,
    isAdaptive: true,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {
            portrait: componentConstants.COMPONENT_ACCORDION_SCREEN,
        },
        xs: {
            landscape: componentConstants.COMPONENT_ACCORDION_SCREEN,
            portrait: componentConstants.COMPONENT_ACCORDION_SCREEN,
        }
    }
};

const ACCORDION_SCREEN = {
    constant: componentConstants.SCREEN_TYPE_ACCORDION,
    component: componentConstants.COMPONENT_ACCORDION_SCREEN,
    isAdaptive: true,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {},
        xs: {}
    }
};

const TITLE_SCREEN = {
    constant: componentConstants.SCREEN_TYPE_TITLE,
    component: componentConstants.COMPONENT_TITLE_SCREEN,
    isAdaptive: false,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {},
        xs: {}
    }
};

const SLIDER_SCREEN = {
    constant: componentConstants.SCREEN_TYPE_SLIDER,
    component: componentConstants.COMPONENT_SLIDER_SCREEN,
    isAdaptive: false,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {},
        xs: {}
    }
};

const HOTSPOT_SCREEN = {
    constant: componentConstants.SCREEN_TYPE_HOTSPOT,
    component: componentConstants.COMPONENT_HOTSPOT_SCREEN,
    isAdaptive: true,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {
            portrait: componentConstants.COMPONENT_ACCORDION_SCREEN,
        },
        xs: {
            landscape: componentConstants.COMPONENT_ACCORDION_SCREEN,
            portrait: componentConstants.COMPONENT_ACCORDION_SCREEN,
        }
    }
};

const VIDEO_SCREEN = {
    constant: componentConstants.SCREEN_TYPE_VIDEO,
    component: componentConstants.COMPONENT_VIDEO_SCREEN,
    isAdaptive: true,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {},
        xs: {
            landscape: componentConstants.COMPONENT_VIDEO_MOBILE_SCREEN,
            portrait: componentConstants.COMPONENT_VIDEO_MOBILE_SCREEN
        }
    }
};

export const SCREEN_TYPES = [
    TITLE_SCREEN,
    TABBED_SCREEN,
    SCENARIO_SCREEN,
    SCROLL_SCREEN,
    SLIDER_SCREEN,
    HOTSPOT_SCREEN,
    VIDEO_SCREEN,
    ACCORDION_SCREEN
];

const TITLE_SCREEN_STANDARD = {
    constant: componentConstants.SCREEN_SUB_TYPE_TITLE_STANDARD,
    component: componentConstants.COMPONENT_SCREEN_SUB_TYPE_TITLE_STANDARD,
    isAdaptive: false,
    isDefault: true,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {},
        xs: {}
    }
};

const TITLE_SCREEN_STANDARD_IMAGE_BASED = {
    constant: componentConstants.SCREEN_SUB_TYPE_TITLE_IMAGE_BASED,
    component: componentConstants.COMPONENT_SCREEN_SUB_TYPE_TITLE_IMAGE_BASED,
    isAdaptive: false,
    isDefault: false,
    adaptiveComponentSizes: {
        lg: {},
        md: {},
        sm: {},
        xs: {}
    }
};
export const TITLE_SCREEN_SUB_TYPES = [
    TITLE_SCREEN_STANDARD,
    TITLE_SCREEN_STANDARD_IMAGE_BASED
];

const CONVERSATION_DIALOG = {
    constant: componentConstants.CONVERSATION_DIALOG,
    component: componentConstants.COMPONENT_CONVERSATION_DIALOG
};

const TEXT = {
    constant: componentConstants.TEXT,
    component: componentConstants.COMPONENT_TEXT
};

const SCORE_INTRODUCTION = {
    constant: componentConstants.SCORE_INTRODUCTION,
    component: componentConstants.COMPONENT_SCORE_INTRODUCTION
};

const KPI_OVERVIEW = {
    constant: componentConstants.KPI_OVERVIEW,
    component: componentConstants.COMPONENT_KPI_OVERVIEW
};

const MULTIPLE_CHOICE = {
    constant: componentConstants.MULTIPLE_CHOICE,
    component: componentConstants.COMPONENT_MULTIPLE_CHOICE
};

const CONVERSATION_CHOICE = {
    constant: componentConstants.CONVERSATION_CHOICE,
    component: componentConstants.COMPONENT_CONVERSATION_CHOICE
};

const GRID_CHOICE = {
    constant: componentConstants.GRID_CHOICE,
    component: componentConstants.COMPONENT_GRID_CHOICE
};

const SWIPE_HORIZONTAL = {
    constant: componentConstants.SWIPE_HORIZONTAL,
    component: componentConstants.COMPONENT_SWIPE_HORIZONTAL
};

const VIDEO = {
    constant: componentConstants.VIDEO,
    component: componentConstants.COMPONENT_VIDEO
};

const LINK = {
    constant: componentConstants.LINK,
    component: componentConstants.COMPONENT_LINK
};


const DOCUMENT = {
    constant: componentConstants.DOCUMENT,
    component: componentConstants.COMPONENT_DOCUMENT
};


const IMAGE = {
    constant: componentConstants.IMAGE,
    component: componentConstants.COMPONENT_IMAGE
};

const LIBRARY_IMAGE = {
    constant: componentConstants.LIBRARY_IMAGE,
    component: componentConstants.COMPONENT_LIBRARY_IMAGE
};

const KPI_GRAPH_RESULTS = {
    constant: componentConstants.KPI_GRAPH_RESULTS,
    component: componentConstants.COMPONENT_KPI_GRAPH_RESULTS
};

const KPI_RESULTS_LIST = {
    constant: componentConstants.KPI_RESULTS_LIST,
    component: componentConstants.COMPONENT_KPI_RESULTS_LIST
};

const THE_END = {
    constant: componentConstants.THE_END,
    component: componentConstants.COMPONENT_THE_END
};

const BADGE_OVERVIEW = {
    constant: componentConstants.BADGE_OVERVIEW,
    component: componentConstants.COMPONENT_BADGE_OVERVIEW
};

const AWARD_BADGE = {
    constant: componentConstants.AWARD_BADGE,
    component: componentConstants.COMPONENT_AWARD_BADGE
};

const VIMEO_VIDEO = {
    constant: componentConstants.VIMEO_VIDEO,
    component: componentConstants.COMPONENT_VIMEO_VIDEO
};

const YOUTUBE_VIDEO = {
    constant: componentConstants.YOUTUBE_VIDEO,
    component: componentConstants.COMPONENT_YOUTUBE
};

const MP4_VIDEO = {
    constant: componentConstants.MP4_VIDEO,
    component: componentConstants.COMPONENT_MP4
};

const SHORT_RESPONSE = {
    constant: componentConstants.SHORT_RESPONSE,
    component: componentConstants.COMPONENT_SHORT_RESPONSE

};

const PRINT_RESPONSES = {
    constant: componentConstants.PRINT_RESPONSES,
    component: componentConstants.COMPONENT_PRINT_RESPONSES

};

export const ASSET_TYPES = [
    CONVERSATION_DIALOG,
    TEXT,
    SCORE_INTRODUCTION,
    KPI_OVERVIEW,
    MULTIPLE_CHOICE,
    CONVERSATION_CHOICE,
    GRID_CHOICE,
    SWIPE_HORIZONTAL,
    VIDEO,
    LINK,
    DOCUMENT,
    IMAGE,
    LIBRARY_IMAGE,
    KPI_GRAPH_RESULTS,
    KPI_RESULTS_LIST,
    THE_END,
    BADGE_OVERVIEW,
    AWARD_BADGE,
    VIMEO_VIDEO,
    YOUTUBE_VIDEO,
    MP4_VIDEO,
    SHORT_RESPONSE,
    PRINT_RESPONSES
];


/*CHILD OBJECTS*/

const CHARACTER_SPEAK = {
    constant: componentConstants.CHARACTER_SPEAK,
    component: componentConstants.COMPONENT_CHARACTER_SPEAK
};

const LEARNER_SPEAK = {
    constant: componentConstants.LEARNER_SPEAK,
    component: componentConstants.COMPONENT_LEARNER_SPEAK
};

const NARRATOR_SPEAK = {
    constant: componentConstants.NARRATOR_SPEAK,
    component: componentConstants.COMPONENT_NARRATOR_SPEAK
};

const SINGLE_ANSWER = {
    constant: componentConstants.SINGLE_ANSWER,
    component: componentConstants.COMPONENT_SINGLE_ANSWER
};

const MULTIPLE_ANSWER = {
    constant: componentConstants.MULTIPLE_ANSWER,
    component: componentConstants.COMPONENT_MULTIPLE_ANSWER
};

const CONVERSATION_SINGLE_ANSWER = {
    constant: componentConstants.CONVERSATION_SINGLE_ANSWER,
    component: componentConstants.COMPONENT_CONVERSATION_SINGLE_ANSWER
};

const CONVERSATION_MULTIPLE_ANSWER = {
    constant: componentConstants.CONVERSATION_MULTIPLE_ANSWER,
    component: componentConstants.COMPONENT_CONVERSATION_MULTIPLE_ANSWER
};


const GRID_SINGLE_ANSWER = {
    constant: componentConstants.GRID_SINGLE_ANSWER,
    component: componentConstants.COMPONENT_GRID_SINGLE_ANSWER
};


const VIMEO_SUB_VIDEO = {
    constant: componentConstants.VIMEO_SUB_VIDEO,
    component: componentConstants.COMPONENT_SUB_VIMEO_VIDEO
};

const YOUTUBE_SUB_VIDEO = {
    constant: componentConstants.YOUTUBE_SUB_VIDEO,
    component: componentConstants.COMPONENT_SUB_YOUTUBE
};

const MP4_SUB_VIDEO = {
    constant: componentConstants.MP4_SUB_VIDEO,
    component: componentConstants.COMPONENT_SUB_MP4
};


export const CHILD_OBJECTS_TYPES = [
    CHARACTER_SPEAK,
    LEARNER_SPEAK,
    NARRATOR_SPEAK,
    SINGLE_ANSWER,
    MULTIPLE_ANSWER,
    CONVERSATION_SINGLE_ANSWER,
    CONVERSATION_MULTIPLE_ANSWER,
    GRID_SINGLE_ANSWER,
    VIMEO_SUB_VIDEO,
    YOUTUBE_SUB_VIDEO,
    MP4_SUB_VIDEO
];

const RESOURCE_DOCUMENT_LINK = {
    constant: componentConstants.RESOURCE_DOCUMENT_LINK,
    component: componentConstants.COMPONENT_RESOURCE_DOCUMENT_LINK
};

const RESOURCE_IMAGE_LINK = {
    constant: componentConstants.RESOURCE_IMAGE_LINK,
    component: componentConstants.COMPONENT_RESOURCE_IMAGE_LINK
};

const RESOURCE_SCREEN_LINK = {
    constant: componentConstants.RESOURCE_SCREEN_LINK,
    component: componentConstants.COMPONENT_RESOURCE_SCREEN_LINK
};

const RESOURCE_URL_LINK = {
    constant: componentConstants.RESOURCE_URL_LINK,
    component: componentConstants.COMPONENT_RESOURCE_URL_LINK
};

const RESOURCE_VIDEO_LINK = {
    constant: componentConstants.RESOURCE_VIDEO_LINK,
    component: componentConstants.COMPONENT_RESOURCE_VIDEO_LINK
};

export const RESOURCE_LINK_TYPES = [
    RESOURCE_DOCUMENT_LINK,
    RESOURCE_IMAGE_LINK,
    RESOURCE_SCREEN_LINK,
    RESOURCE_URL_LINK,
    RESOURCE_VIDEO_LINK
];

export const ALWAY_SCROLL_AFTER = [
    componentConstants.MULTIPLE_CHOICE,
    componentConstants.CONVERSATION_CHOICE,
    componentConstants.GRID_CHOICE,
    componentConstants.SWIPE_HORIZONTAL,
    componentConstants.VIDEO,
    componentConstants.SHORT_RESPONSE
];

export const CHECK_SCROLL_AFTER = [
    componentConstants.CONVERSATION_DIALOG,
    componentConstants.TEXT,
    componentConstants.SCORE_INTRODUCTION,
    componentConstants.KPI_OVERVIEW,
    componentConstants.LINK,
    componentConstants.DOCUMENT,
    componentConstants.IMAGE,
    componentConstants.LIBRARY_IMAGE,
    componentConstants.KPI_GRAPH_RESULTS,
    componentConstants.KPI_RESULTS_LIST,
    componentConstants.THE_END,
    componentConstants.BADGE_OVERVIEW,
    componentConstants.AWARD_BADGE,
    componentConstants.PRINT_RESPONSES
];


export const AUTO_NAVIGATE_IF_LAST_ON_INCOMPLETE_SCREEN = [
    componentConstants.MULTIPLE_CHOICE,
    componentConstants.CONVERSATION_CHOICE,
    componentConstants.GRID_CHOICE,
    componentConstants.SWIPE_HORIZONTAL
];

/*
*  CONVERSATION_DIALOG,
    TEXT,
    SCORE_INTRODUCTION,
    KPI_OVERVIEW,
    MULTIPLE_CHOICE,
    CONVERSATION_CHOICE,
    GRID_CHOICE,
    SWIPE_HORIZONTAL,
    VIDEO,
    LINK,
    DOCUMENT,
    IMAGE,
    LIBRARY_IMAGE,
    KPI_GRAPH_RESULTS,
    KPI_RESULTS_LIST,
    THE_END,
    BADGE_OVERVIEW,
    AWARD_BADGE
* */


/** WEBPACK FOOTER **
 ** ./src/models/componentModels.js
 **/